/* eslint eqeqeq: "off" */
import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import {
  Col,
  Row,
  Skeleton,
  // DatePicker,
  Table,
  // Select,
  AutoComplete,
  Input,
  Spin,
  Select,
  Modal,
  Tooltip,
  // Button,
} from "antd";
import "./index.css";
import { DownloadOutlined } from "@ant-design/icons";
import { BiCalendar, BiLock, BiLockOpen } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { isEmpty } from "lodash";
import useMedia from "use-media-antd-query";
import { loadManageOrganizationList } from "../../store/reports/actions";
import DatePicker from "react-datepicker";
import api from "../../helpers";
import toast from "react-hot-toast";

const ManageOrganization = (props) => {
  const dispatch = useDispatch();

  const media = useMedia();

  //initial state values
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [statusList, setStatusList] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [organizationId, setOrganizationId] = useState({
    _id: "",
    status: "",
  });
  const [pageValue, setPageValue] = useState({
    page: "",
    pageSize: "",
  });
  const [confirmationModal, setConfirmationModal] = useState(false);

  const orgPayload = {
    page: pageValue && pageValue.page ? pageValue.page : 1,
    limit: pageValue && pageValue.pageSize ? pageValue.pageSize : 10,
  };
  useEffect(() => {
    setLoading(true);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
      setLoading(false);
    }, 2000);
    dispatch(loadManageOrganizationList(orgPayload));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // reducer state
  const { manage_organization_list = {} } = useSelector(
    (state) => state.Reports
  );

  //header columns
  const HeaderData = [
    {
      key: "createdAt",
      title: <p className="font-label text-[13px] font-semibold">Date</p>,
      dataIndex: "createdAt",
      width: 120,
      // fixed: "left",
      sorter: (a, b) => a.createdAt.length - b.createdAt.length,
    },
    {
      key: "action",
      title: <p className="font-label text-[13px] font-semibold">Action</p>,
      dataIndex: "action",
      width: 100,
    },
    {
      key: "organizationName",
      title: <p className="font-label text-[13px] font-semibold">Org Name</p>,
      dataIndex: "organizationName",
      width: 170,
    },
    {
      key: "organizationCategoryName",
      title: (
        <p className="font-label text-[13px] font-semibold">Org Category</p>
      ),
      dataIndex: "organizationCategoryName",
      width: 140,
    },
    {
      key: "organizationPhone",
      title: <p className="font-label text-[13px] font-semibold">Org Mobile</p>,
      dataIndex: "organizationPhone",
      width: 140,
    },
    {
      key: "userName",
      title: <p className="font-label text-[13px] font-semibold">User Name</p>,
      dataIndex: "userName",
      width: 150,
    },
    {
      key: "businessRegTypeName",
      title: <p className="font-label text-[13px] font-semibold">Reg Type</p>,
      dataIndex: "businessRegTypeName",
      width: 200,
    },
    {
      key: "planName",
      title: <p className="font-label text-[13px] font-semibold">Plan Name</p>,
      dataIndex: "planName",
      width: 120,
    },
    {
      key: "sizeName",
      title: <p className="font-label text-[13px] font-semibold">Org Size</p>,
      dataIndex: "sizeName",
      width: 120,
    },
    {
      key: "isEnableMultiLogin",
      title: (
        <p className="font-label text-[13px] font-semibold">Multi Login</p>
      ),
      dataIndex: "isEnableMultiLogin",
      width: 120,
    },
    {
      key: "address",
      title: <p className="font-label text-[13px] font-semibold">Address</p>,
      dataIndex: "address",
      width: 200,
    },
    {
      key: "status",
      title: <p className="font-label text-[13px] font-semibold">Status</p>,
      dataIndex: "status",
      width: 120,
    },
  ];

  const escapeCSVField = (field) => {
    if (typeof field === "string" && field.includes(",")) {
      return `"${field}"`;
    }
    return field;
  };

  //filters

  const [filteredValues, setFilteredValues] = useState("");
  const applyFilters = () => {
    var fromDateFilter = fromDate ? moment(fromDate).format("YYYY-MM-DD") : "";
    var toDateFilter = toDate ? moment(toDate).format("YYYY-MM-DD") : "";

    var status = statusList && statusList.value ? statusList.value : "";

    let searchValue = {};
    searchValue.page = pageValue && pageValue.page ? pageValue.page : 1;

    searchValue.limit =
      pageValue && pageValue.pageSize ? pageValue.pageSize : 10;

    if (fromDateFilter) {
      searchValue.fromDate = fromDateFilter;
    }
    if (toDateFilter) {
      searchValue.toDate = toDateFilter;
    }
    if (status) {
      searchValue.status = status;
    }
    // if (vendorId) {
    //   searchValue.vendorId = vendorId;
    // }

    const searchFilterValues = Object.keys(searchValue).forEach(
      (data) => !searchValue[data] && delete searchValue[data]
    );
    console.log(searchFilterValues, "searchFilterValues");
    setFilteredValues(searchValue);
    setTableLoading(true);
    dispatch(loadManageOrganizationList(searchValue));
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  const [manageOrganizationRows, setmanageOrganizationRows] = useState([
    {
      _id: "",
      organizationName: "",
      organizationEmail: "",
      organizationPhone: "",
      userId: "",
      organizationCategory: "",
      organizationCategoryName: "",
      countryId: "",
      stateId: "",
      isGst: "",
      currency: "",
      currency_code: "",
      currencyId: "",
      planId: "",
      planName: "",
      sizeId: "",
      sizeName: "",
      wheredofindMbook: "",
      communicateLanguageId: "",
      communicateLanguageName: "",
      createdAt: "",
      updatedAt: "",
      businessRegTypeId: "",
      businessRegTypeName: "",
      updatedBy: "",
      address: "",
      termsandconditions: "",
      city: "",
      panNo: "",
      enableTds: "",
      pinCode: "",
      isEnableMultiLogin: "",
      gstType: "",
      logo: "",
      signature: "",
      action: "",
      status: "",
      userEmail: "",
      userName: "",
    },
  ]);

  const manageOrganizationTable =
    !isEmpty(manage_organization_list) &&
    manage_organization_list.data.length > 0
      ? manage_organization_list.data.map((data) => {
          return {
            _id: data._id,
            organizationName: (
              <div
                className={"capitalize text-start font-label text-[13px]"}
                // className={
                //   data.isService === true
                //     ? "text-[#08a35ae0] font-semibold text-start"
                //     : "text-[#bb1d0d] font-semibold text-start"
                // }
              >
                {data.organizationName}
              </div>
            ),
            organizationEmail: data.organizationEmail,
            organizationPhone: (
              <div className={"capitalize text-start font-label text-[13px]"}>
                {data.organizationPhone}
              </div>
            ),
            organizationCategory: (
              <div className={"capitalize text-start font-label text-[13px]"}>
                {data.organizationCategory}
              </div>
            ),
            organizationCategoryName: (
              <div className={"capitalize text-start font-label text-[13px]"}>
                {data.organizationCategoryName}
              </div>
            ),
            countryId: data.countryId,
            stateId: data.stateId,
            isGst: data.isGst,
            currency: data.currency,
            currency_code: data.currency_code,
            currencyId: data.currencyId,
            planId: data.planId,
            planName: (
              <div className={"capitalize text-start font-label text-[13px]"}>
                {data.planName ? data.planName : "--"}
              </div>
            ),
            sizeId: (
              <div className={"capitalize text-start font-label text-[13px]"}>
                {data.sizeId}
              </div>
            ),
            sizeName: (
              <div className={"capitalize text-start font-label text-[13px]"}>
                {data.sizeName ? data.sizeName : "--"}
              </div>
            ),
            wheredofindMbook: data.wheredofindMbook,
            communicateLanguageId: data.communicateLanguageId,
            communicateLanguageName: data.communicateLanguageName,
            createdAt: data.createdAt
              ? moment(data.createdAt).format("DD-MM-YYYY")
              : "",
            updatedAt: data.updatedAt,
            businessRegTypeId: (
              <div className={"capitalize text-start font-label text-[13px]"}>
                {data.businessRegTypeId}
              </div>
            ),
            businessRegTypeName: (
              <div className={"capitalize text-start font-label text-[13px]"}>
                {data.businessRegTypeName ? data.businessRegTypeName : "--"}
              </div>
            ),
            updatedBy: data.updatedBy,
            address:
              data.address !== undefined ? (
                <div
                  className={"capitalize text-start font-label text-[13px]"}
                  // className={
                  //   data.isService === true
                  //     ? "text-[#08a35ae0] font-semibold text-start"
                  //     : "text-[#bb1d0d] font-semibold text-start"
                  // }
                >
                  {data.address}
                </div>
              ) : (
                "--"
              ),
            isEnableMultiLogin: (
              <div
                className={
                  data.isEnableMultiLogin === true
                    ? "text-[#08a35ae0] font-semibold text-start"
                    : "text-[#bb1d0d] font-semibold text-start"
                }
              >
                {data.isEnableMultiLogin === true ? "YES" : "NO"}
              </div>
            ),
            termsandconditions: data.termsandconditions,
            city: data.city,
            panNo: data.panNo,
            enableTds: data.enableTds,
            pinCode: data.pinCode,
            gstType: data.gstType,
            logo: data.logo,
            signature: data.signature,
            action: (
              <Tooltip
                title={
                  data.status !== undefined && data.status == 1
                    ? "Active"
                    : "Inactive"
                }
                placement="top"
              >
                <div
                  className={
                    data.status !== undefined && data.status == 1
                      ? "cursor-pointer bg-[#08a35ae0] pt-1 pb-1 pr-2 pl-2 h-[35px] w-[37px] rounded-sm hover:bg-[#0b9b57e0] focus:bg-[#0b9b57e0] text-[white] font-label font-semibold text-start"
                      : "cursor-pointer bg-[#e74c3c] pt-1 pb-1 pr-2 pl-2 h-[35px] w-[37px] rounded-sm hover:bg-[#bb1d0d] focus:bg-[#bb1d0d] text-[white] font-label font-semibold text-start"
                  }
                  onClick={() => {
                    setOrganizationId({
                      _id: data._id,
                      status: data.status !== undefined ? data.status : "",
                    });
                    setConfirmationModal(true);
                  }}
                >
                  {data.status !== undefined && data.status == 1 ? (
                    <BiLockOpen className="text-[22px]" />
                  ) : (
                    <BiLock className="text-[22px]" />
                  )}
                </div>
              </Tooltip>
            ),
            status: (
              <div
                className={
                  data.status !== undefined && data.status === 1
                    ? "flex justify-center cursor-pointer bg-[#08a35ae0] pt-1 pb-1 pr-2 pl-2 rounded-sm hover:bg-[#0b9b57e0] focus:bg-[#0b9b57e0] text-[white] font-label text-start"
                    : "flex justify-center cursor-pointer bg-[#e74c3c] pt-1 pb-1 pr-2 pl-2 rounded-sm hover:bg-[#bb1d0d] focus:bg-[#bb1d0d] text-[white] font-label text-start"
                }
              >
                {data.status !== undefined && data.status === 1
                  ? "Active"
                  : "Inactive"}
              </div>
            ),
            userId:
              data.user !== undefined && data.user._id !== undefined
                ? data.user._id
                : "",

            userEmail:
              data.user !== undefined && data.user.email !== undefined
                ? data.user.email
                : "",
            userName:
              data.user !== undefined && data.user.name !== undefined ? (
                <div className={"capitalize text-start font-label text-[13px]"}>
                  {data.user.name}
                </div>
              ) : (
                "--"
              ),
          };
        })
      : [];

  useEffect(() => {
    if (manageOrganizationTable && manageOrganizationTable.length > 0) {
      setmanageOrganizationRows(manageOrganizationTable);
    } else {
      setmanageOrganizationRows([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [manage_organization_list]);

  //paginations
  const handlePagination = (page, pageSize) => {
    const filter = {
      page: page,
      limit: pageSize,
      status: filteredValues ? filteredValues.status : "",
      fromDate: filteredValues ? filteredValues.fromDate : "",
      toDate: filteredValues ? filteredValues.toDate : "",
    };

    const searchFilterValues = Object.keys(filter).forEach(
      (data) => !filter[data] && delete filter[data]
    );
    console.log(searchFilterValues, "searchFilterValues");
    setPageValue({ page: page, pageSize: pageSize });
    dispatch(loadManageOrganizationList(filter));
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };
  console.log(pageValue, "pageValue");

  //search , print and download
  const [search, setSearch] = useState("");

  const handleSearch = (event) => {
  
 const filteredRows = manageOrganizationTable.filter(
      (row) =>
        Object.values(row).some((data) =>
          String(data).toLowerCase().includes(event.target.value.toLowerCase())
        )
      // row.productName.toLowerCase().includes(event.target.value.toLowerCase())
    );
    setSearch(event.target.value);
    setmanageOrganizationRows(filteredRows);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  //Download functionality

  //Download functionality
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType });

    const a = document.createElement("a");
    a.download = fileName;
    a.href = window.URL.createObjectURL(blob);
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
  };

  const handleDownloadPDF = () => {
    setDownloadLoading(true);

    var fromDateFilter = fromDate ? moment(fromDate).format("YYYY-MM-DD") : "";
    var toDateFilter = toDate ? moment(toDate).format("YYYY-MM-DD") : "";

    var status = statusList && statusList.value ? statusList.value : "";

    let searchValue = {};
    searchValue.page = pageValue && pageValue.page ? pageValue.page : 1;
    searchValue.limit =
      pageValue && pageValue.pageSize ? pageValue.pageSize : 10;

    if (fromDateFilter) {
      searchValue.fromDate = fromDateFilter;
    }
    if (toDateFilter) {
      searchValue.toDate = toDateFilter;
    }
    if (status) {
      searchValue.status = status;
    }
    // if (vendorId) {
    //   searchValue.vendorId = vendorId;
    // }

    const searchFilterValues = Object.keys(searchValue).forEach(
      (data) => !searchValue[data] && delete searchValue[data]
    );
    console.log(searchFilterValues, "searchFilterValues");

    api
      .post(`/org/exportallorganizations`, searchValue)
      .then((response) => {
        const stockReportExcel =
          !isEmpty(response) && response.data.length > 0
            ? response.data.map((data, index) => {
                return {
                  key: index + 1,
                  _id: data._id,
                  organizationName: data.organizationName,
                  organizationEmail: data.organizationEmail,
                  organizationPhone: data.organizationPhone,
                  organizationCategory: data.organizationCategory,
                  organizationCategoryName: data.organizationCategoryName
                    ? data.organizationCategoryName
                    : "--",
                  countryId: data.countryId,
                  stateId: data.stateId,
                  isGst: data.isGst,
                  currency: data.currency,
                  currency_code: data.currency_code,
                  currencyId: data.currencyId,
                  planId: data.planId,
                  planName: data.planName ? data.planName : "--",
                  sizeId: data.sizeId,
                  sizeName: data.sizeName ? data.sizeName : "--",
                  wheredofindMbook: data.wheredofindMbook,
                  communicateLanguageId: data.communicateLanguageId,
                  communicateLanguageName: data.communicateLanguageName
                    ? data.communicateLanguageName
                    : "--",
                  createdAt: data.createdAt
                    ? moment(data.createdAt).format("DD-MM-YYYY")
                    : "--",
                  updatedAt: data.updatedAt,
                  businessRegTypeId: data.businessRegTypeId,
                  businessRegTypeName: data.businessRegTypeName
                    ? data.businessRegTypeName
                    : "--",
                  updatedBy: data.updatedBy,
                  address:
                    data.address !== undefined
                      ? escapeCSVField(data.address)
                      : "",
                  termsandconditions: data.termsandconditions,
                  city: data.city,
                  panNo: data.panNo,
                  enableTds: data.enableTds,
                  pinCode: data.pinCode,
                  isEnableMultiLogin:
                    data.isEnableMultiLogin === true ? "YES" : "NO",
                  gstType: data.gstType,
                  logo: data.logo,
                  signature: data.signature,
                  action: "",
                  status: data.status === 1 ? "Active" : "Inactive",
                  userId:
                    data.user !== undefined && data.user._id !== undefined
                      ? data.user._id
                      : "",

                  userEmail:
                    data.user !== undefined && data.user.email !== undefined
                      ? data.user.email
                      : "",
                  userName:
                    data.user !== undefined && data.user.name !== undefined
                      ? data.user.name
                      : "--",
                };
              })
            : [];
        setTimeout(() => {
          let headerData = [
            "S.No, Date,Organization Name,Org Category,Org Mobile,User Name, Reg Type,Plan Name, Org Size, Multi Login, Address, Status",
          ];

          let usersCsv = !isEmpty(stockReportExcel)
            ? stockReportExcel.reduce((acc, user) => {
                const {
                  key,
                  createdAt,
                  organizationName,
                  organizationCategoryName,
                  organizationPhone,
                  userName,
                  businessRegTypeName,
                  planName,
                  sizeName,
                  isEnableMultiLogin,
                  address,
                  status,
                } = user;
                acc.push([
                  key,
                  createdAt,
                  organizationName,
                  organizationCategoryName,
                  organizationPhone,
                  userName,
                  businessRegTypeName,
                  planName,
                  sizeName,
                  isEnableMultiLogin,
                  address,
                  status,
                ]);

                return acc;
              }, [])
            : false;

          const usersList =
            !isEmpty(usersCsv) && usersCsv.length > 0 ? usersCsv : [];

          downloadFile({
            data: [...headerData, ...usersList].join("\n"),
            fileName: "ManageOrganization.csv",
            fileType: "text/csv",
          });
          setDownloadLoading(false);
        }, 2500);
        return response.data;
      })
      .catch((error) => Promise.reject(error));
  };

  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  //date and iconCalendarClasses
  const dateFieldClasses =
    media == "sm"
      ? "organization-label rounded-sm border border-1 h-[40px] w-[200%] mt-2"
      : media == "xs"
      ? "organization-label rounded-sm border border-1 h-[40px] w-[125%] mt-2"
      : media == "lg" || media == "md"
      ? "organization-label rounded-sm border border-1 h-[40px] w-[100%]"
      : windowDimensions.width >= 1200 && windowDimensions.width < 1300
      ? "organization-label rounded-sm border border-1 h-[40px] w-[116%]"
      : windowDimensions.width >= 1300 && windowDimensions.width < 1400
      ? "organization-label rounded-sm border border-1 h-[40px] w-[129%]"
      : windowDimensions.width >= 1400 && windowDimensions.width < 1500
      ? "organization-label rounded-sm border border-1 h-[40px] w-[141%]"
      : windowDimensions.width >= 1500 && windowDimensions.width < 1600
      ? "organization-label rounded-sm border border-1 h-[40px] w-[155%]"
      : windowDimensions.width >= 1600 && windowDimensions.width < 1700
      ? "organization-label rounded-sm border border-1 h-[40px] w-[168%]"
      : windowDimensions.width >= 1700 && windowDimensions.width < 1800
      ? "organization-label rounded-sm border border-1 h-[40px] w-[180%]"
      : windowDimensions.width >= 1800 && windowDimensions.width < 1900
      ? "organization-label rounded-sm border border-1 h-[40px] w-[194%]"
      : windowDimensions.width >= 1900 && windowDimensions.width < 2000
      ? "organization-label rounded-sm border border-1 h-[40px] w-[206%]"
      : windowDimensions.width >= 2000 && windowDimensions.width < 2150
      ? "organization-label rounded-sm border border-1 h-[40px] w-[218%]"
      : windowDimensions.width >= 2100 && windowDimensions.width < 2200
      ? "organization-label rounded-sm border border-1 h-[40px] w-[239%]"
      : windowDimensions.width >= 2200 && windowDimensions.width < 2300
      ? "organization-label rounded-sm border border-1 h-[40px] w-[250%]"
      : windowDimensions.width >= 2300 && windowDimensions.width < 2400
      ? "organization-label rounded-sm border border-1 h-[40px] w-[266%]"
      : windowDimensions.width >= 2400 && windowDimensions.width < 2600
      ? "organization-label rounded-sm border border-1 h-[40px] w-[273%]"
      : windowDimensions.width >= 2600
      ? "organization-label rounded-sm border border-1 h-[40px] w-[303%]"
      : "organization-label rounded-sm border border-1 h-[40px] w-[145%]";

  const iconCalendarClasses =
    media == "sm"
      ? "top-[12px] text-[16px] right-[-173px] text-[#9e9e9e]"
      : media == "xs"
      ? "top-[12px] text-[16px] right-[-30px] text-[#9e9e9e]"
      : media == "md" || media == "lg"
      ? "top-[3px] text-[16px] right-[3px] text-[#9e9e9e]"
      : windowDimensions.width >= 1200 && windowDimensions.width < 1300
      ? "top-[3px] text-[16px] right-[-28px] text-[#9e9e9e]"
      : windowDimensions.width >= 1300 && windowDimensions.width < 1400
      ? "top-[3px] text-[16px] right-[-54px] text-[#9e9e9e]"
      : windowDimensions.width >= 1400 && windowDimensions.width < 1500
      ? "top-[3px] text-[16px] right-[-74px] text-[#9e9e9e]"
      : windowDimensions.width >= 1500 && windowDimensions.width < 1600
      ? "top-[3px] text-[16px] right-[-101px] text-[#9e9e9e]"
      : windowDimensions.width >= 1600 && windowDimensions.width < 1700
      ? "top-[3px] text-[16px] right-[-127px] text-[#9e9e9e]"
      : windowDimensions.width >= 1700 && windowDimensions.width < 1800
      ? "top-[3px] text-[16px] right-[-148px] text-[#9e9e9e]"
      : windowDimensions.width >= 1800 && windowDimensions.width < 1900
      ? "top-[3px] text-[16px] right-[-172px] text-[#9e9e9e]"
      : windowDimensions.width >= 1900 && windowDimensions.width < 2000
      ? "top-[3px] text-[16px] right-[-197px] text-[#9e9e9e]"
      : windowDimensions.width >= 2000 && windowDimensions.width < 2150
      ? "top-[3px] text-[16px] right-[-222px] text-[#9e9e9e]"
      : windowDimensions.width >= 2150 && windowDimensions.width < 2200
      ? "top-[3px] text-[16px] right-[-254px] text-[#9e9e9e]"
      : windowDimensions.width >= 2200 && windowDimensions.width < 2300
      ? "top-[3px] text-[16px] right-[-271px] text-[#9e9e9e]"
      : windowDimensions.width >= 2300 && windowDimensions.width < 2400
      ? "top-[3px] text-[16px] right-[-286px] text-[#9e9e9e]"
      : windowDimensions.width >= 2400 && windowDimensions.width < 2600
      ? "top-[3px] text-[16px] right-[-312px] text-[#9e9e9e]"
      : windowDimensions.width >= 2600
      ? "top-[3px] text-[16px] right-[-370px] text-[#9e9e9e]"
      : "top-[3px] text-[16px] right-[-78px] text-[#9e9e9e]";
  const CustomInput = React.forwardRef(({ value, onClick, mode }, ref) => (
    <input
      ref={ref}
      value={value}
      onClick={onClick}
      readOnly // IMPORTANT: prevents issues with focus/click
      className={dateFieldClasses}
      placeholder={mode === "toDate" ? "Select To Date" : "Select From Date"}
    />
  ));
  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Manage Organization | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm bg-[#ffffff]">
        <Col span={24}>
          <div className="font-poppins border border-b-1 border-x-0 border-t-0 pl-[20px] pr-[20px] mt-2 pb-2">
            <div className="flex">
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[16px] font-semibold"
              >
                Manage Organization
              </h1>
            </div>
          </div>
        </Col>
      </Row>
      <Row className="w-[100%]">
        <Col
          span={24}
          className={
            media === "sm" || media === "xs"
              ? "mt-2 pr-4 pl-4 pt-3 pb-2 h-[62%] mb-4 bg-[#ffffff] rounded-md"
              : windowDimensions.height >= 500 && windowDimensions.height <= 700
              ? "mt-2 pr-4 pl-4 pt-3 pb-2 h-[32%] mb-4 bg-[#ffffff] rounded-md"
              : windowDimensions.height >= 700 && windowDimensions.height < 1000
              ? "mt-2 pr-4 pl-4 pt-3 pb-2 h-[23%] mb-4 bg-[#ffffff] rounded-md"
              : "mt-2 pr-4 pl-4 pt-3 pb-2 h-[16%] mb-4 bg-[#ffffff] rounded-md"
          }
        >
          <Row className="pr-2 pl-2 pt-3 pb-2 rounded-md">
            <Col
              md={6}
              lg={6}
              sm={24}
              xs={24}
              className={media == "sm" || media == "xs" ? "mb-3 pr-3" : "pr-3"}
            >
              {loading ? (
                <Skeleton.Input
                  style={{
                    minWidth:
                      media === "xxl"
                        ? "185%"
                        : media == "sm" || media == "xs"
                        ? "255%"
                        : "125%",
                    height: "35px",
                    marginTop: media == "sm" || media == "xs" ? "6px" : "",
                  }}
                ></Skeleton.Input>
              ) : (
                <Select
                  value={statusList}
                  onChange={(newValue, options) =>
                    setStatusList({ label: options.label, value: newValue })
                  }
                  placeholder="Select Status"
                  // mode="multiple"
                  maxTagTextLength={11}
                  maxTagCount={"responsive"}
                  options={[
                    { label: "Active", value: 1 },
                    { label: "Inactive", value: 2 },
                  ]}
                  className={
                    // vendorList.length >= 2
                    //   ? "w-[100%] h-[100%]"
                    //   :
                    media == "sm"
                      ? "w-[350px] font-label h-[40px] mt-2"
                      : media == "xs"
                      ? "w-[230px] font-label h-[40px] mt-2"
                      : "w-[100%] font-label h-[40px]"
                  }
                  rootClassName="purchase-label"
                />
              )}
            </Col>
            <Col
              md={6}
              lg={6}
              sm={24}
              xs={24}
              className={
                media === "lg" ||
                media === "xl" ||
                media === "xxl" ||
                media === "md"
                  ? "pr-3"
                  : "mb-3 pr-3"
              }
            >
              {loading ? (
                <Skeleton.Input
                  style={{
                    minWidth:
                      media === "xxl"
                        ? "185%"
                        : media == "sm" || media == "xs"
                        ? "255%"
                        : "125%",
                    height: "35px",
                  }}
                ></Skeleton.Input>
              ) : (
                <DatePicker
                  toggleCalendarOnIconClick={true}
                  selected={fromDate}
                  className={dateFieldClasses}
                  icon={<BiCalendar className={iconCalendarClasses} />}
                  style={{
                    fontFamily: "Poppins",
                  }}
                  onChange={(date) => setFromDate(date)}
                  popperClassName={"z-10 ml-3"}
                  showIcon
                  customInput={<CustomInput mode={"fromDate"} />}
                  shouldCloseOnSelect={true} // This is the default
                  placeholderText="Select From Date"
                />
              )}
            </Col>
            <Col
              md={6}
              lg={6}
              sm={24}
              xs={24}
              className={
                media === "lg" ||
                media === "xl" ||
                media === "xxl" ||
                media === "md"
                  ? "pr-3"
                  : "pr-3"
              }
            >
              {loading ? (
                <Skeleton.Input
                  style={{
                    minWidth:
                      media === "xxl"
                        ? "185%"
                        : media == "sm" || media == "xs"
                        ? "255%"
                        : "125%",
                    height: "35px",
                  }}
                ></Skeleton.Input>
              ) : (
                <DatePicker
                  toggleCalendarOnIconClick={true}
                  selected={toDate}
                  className={dateFieldClasses}
                  icon={<BiCalendar className={iconCalendarClasses} />}
                  style={{
                    fontFamily: "Poppins",
                  }}
                  onChange={(date) => {
                    setToDate(date);
                  }}
                  popperClassName={"z-10 ml-3"}
                  showIcon
                  customInput={<CustomInput mode={"toDate"} />}
                  shouldCloseOnSelect={true} // This is the default
                  placeholderText="Select To Date"
                />
              )}
            </Col>
            <Col
              md={24}
              lg={24}
              sm={24}
              xs={24}
              className={
                media == "sm" || media == "xs"
                  ? "pr-2 w-[100%] mt-3"
                  : "pr-2 mt-3"
              }
            >
              <Row
                className={
                  media == "sm" || media == "xs" ? "flex" : "flex justify-end"
                }
              >
                {/* <Col
                  md={12}
                  lg={12}
                  sm={24}
                  xs={24}
                  className="pl-0 md:pl-10 lg:pl-10 xl:pl-10"
                > */}
                {loading ? (
                  <Skeleton.Input
                    style={{
                      width:
                        media == "md"
                          ? "180px"
                          : media == "sm"
                          ? "300px"
                          : "250px",
                      height: "35px",
                    }}
                  ></Skeleton.Input>
                ) : (
                  <div
                    className={
                      media == "sm" || media == "xs" ? "flex w-[100%]" : "flex"
                    }
                  >
                    <div
                      style={{
                        fontFamily: "Poppins",
                        fontSize: "13px",
                      }}
                      onClick={() => {
                        setFromDate("");
                        setToDate("");
                        setStatusList([]);
                        dispatch(loadManageOrganizationList(orgPayload));
                        setTableLoading(true);
                        setFilteredValues({
                          page:
                            pageValue && pageValue.page ? pageValue.page : 1,
                          limit:
                            pageValue && pageValue.pageSize
                              ? pageValue.pageSize
                              : 10,
                        });
                        setTimeout(() => {
                          setTableLoading(false);
                        }, 2000);
                      }}
                      className={
                        media == "sm" || media == "xs"
                          ? "cursor-pointer ml-0 text-[#ffffff] text-center rounded-md pt-2 pb-2 pl-5 pr-5 mr-2 bg-[#e74c3c] hover hover:bg-[red]"
                          : "cursor-pointer ml-5 text-[#ffffff] text-center rounded-md pt-2 pb-2 pl-5 pr-5 mr-2 bg-[#e74c3c] hover hover:bg-[red]"
                      }
                    >
                      Reset
                    </div>
                    <div
                      style={{
                        fontFamily: "Poppins",
                        fontSize: "13px",
                      }}
                      onClick={() => applyFilters()}
                      className="cursor-pointer ml-1 text-[#ffffff] text-center rounded-md pt-2 pb-2 pl-5 pr-5 bg-[#12b76ae0] hover hover:bg-[green]"
                    >
                      Filter
                    </div>
                  </div>
                )}
                {/* </Col> */}
              </Row>
            </Col>
          </Row>
        </Col>
        {/* print, download section */}
        <Col
          md={24}
          lg={24}
          sm={24}
          xs={24}
          className={
            windowDimensions.height > 700 &&
            windowDimensions.height < 830 &&
            manageOrganizationTable.length > 0
              ? "mt-[1px] h-[80%] bg-[#ffffff] rounded-md"
              : windowDimensions.height > 830 &&
                windowDimensions.height < 1000 &&
                manageOrganizationTable.length > 0
              ? "mt-[1px] h-[80%] bg-[#ffffff] rounded-md"
              : windowDimensions.height > 700 &&
                windowDimensions.height < 830 &&
                manageOrganizationTable.length == 0
              ? "mt-[1px] h-[80%] bg-[#ffffff] rounded-md"
              : windowDimensions.height > 830 &&
                windowDimensions.height < 1000 &&
                manageOrganizationTable.length == 0
              ? "mt-[1px] h-[56vh] bg-[#ffffff] rounded-md"
              : windowDimensions.height >= 1000 &&
                manageOrganizationTable.length == 0
              ? "mt-[1px] h-[56vh] bg-[#ffffff] rounded-md"
              : windowDimensions.height >= 1000
              ? "mt-[1px] h-[82%] bg-[#ffffff] rounded-md"
              : "bg-[#ffffff] rounded-md"
          }
        >
          <Row className="flex flex-col">
            <Col md={24} lg={24} sm={24} xs={24} className="mt-4 mb-3 pb-5">
              <Row className="flex justify-between">
                <Col
                  md={10}
                  lg={10}
                  sm={24}
                  xs={24}
                  className="pr-3 lg:pr-0 md:pr-0 pl-4"
                >
                  {loading ? (
                    <Skeleton.Input
                      style={{
                        minWidth:
                          media === "xxl"
                            ? "185%"
                            : media == "sm" || media == "xs"
                            ? "255%"
                            : "125%",
                        height: "35px",
                      }}
                    ></Skeleton.Input>
                  ) : (
                    <div
                      className={
                        media === "sm" || media === "xs"
                          ? "w-[59%]"
                          : "w-[100%] lg:w-[65%] md:w-[65%]"
                      }
                    >
                      <AutoComplete
                        style={{
                          marginRight: "10px",
                          fontSize: "11px",
                        }}
                        // onClick={() => setSearchOpen(false)}
                        className="w-[100%]"
                      >
                        <Input.Search
                          size="middle"
                          placeholder="Search Organization"
                          style={{
                            fontFamily: "Poppins",
                            // minHeight: "35px",
                            // border: "1px solid lightgray",
                            fontSize: "11px",
                          }}
                          className="rounded-sm"
                          // bordered={false}
                          name="search"
                          value={search}
                          onChange={(e) => handleSearch(e)}
                        />
                      </AutoComplete>
                    </div>
                  )}
                </Col>
                <Col md={14} lg={14} sm={24} xs={24} className="pr-1">
                  <Row className="flex justify-end">
                    <Col
                      md={7}
                      lg={7}
                      sm={24}
                      xs={24}
                      className="pr-3 sm:pr-3 ml-3 sm:ml-3 mt-3 lg:mt-0 md:mt-0 lg:ml-10 md:ml-10"
                    >
                      {loading ? (
                        <Skeleton.Input
                          style={{
                            minWidth:
                              media === "xxl"
                                ? "185%"
                                : media == "sm" || media == "xs"
                                ? "245%"
                                : "125%",
                            paddingRight: media == "md" ? "20px" : "14px",
                            height: "35px",
                            marginLeft:
                              media == "sm" || media == "xs" ? "10px" : "",
                          }}
                        ></Skeleton.Input>
                      ) : (
                        <Row>
                          <Col
                            md={24}
                            lg={24}
                            sm={14}
                            xs={14}
                            onClick={handleDownloadPDF}
                            className={
                              media == "sm" || media == "xs"
                                ? "cursor-pointer flex justify-center border pt-[5px] pb-[5px] ml-4 mr-4 rounded-sm border-1"
                                : // ? "cursor-pointer border pt-[5px] pb-[5px] ml-3 mr-2 rounded-sm border-1"
                                  "cursor-pointer flex justify-center border pt-[5px] pb-[5px] rounded-sm border-1"
                            }
                            style={{
                              fontFamily: "Poppins",
                            }}
                          >
                            {downloadLoading ? (
                              <p className="flex justify-center">
                                {" "}
                                <Spin className="mr-2" /> Downloading
                              </p>
                            ) : (
                              <p className="flex">
                                <DownloadOutlined className="text-[16px] mr-3" />{" "}
                                Download
                              </p>
                            )}
                          </Col>
                        </Row>
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>

            <Col
              span={24}
              className={
                media === "xxl"
                  ? "pt-2 pl-4 purchase-invoice-orders"
                  : "pr-1 pl-4 purchase-invoice-orders"
              }
            >
              <Table
                style={{
                  overflow: "hidden",
                }}
                bordered
                columns={HeaderData}
                dataSource={
                  manageOrganizationRows &&
                  manageOrganizationRows.length > 0 &&
                  !isEmpty(manageOrganizationRows[0]._id)
                    ? manageOrganizationRows
                    : []
                }
                rowClassName={"table-row-label p-0"}
                expandable={{
                  // expandedRowRender: expandedRowRender,
                  defaultExpandAllRows: false,
                  // expandIconColumnIndex: 5,
                }}
                pagination={{
                  defaultPageSize: 10,
                  showSizeChanger: true,
                  onShowSizeChange: (e) => console.log(e, "page limit"),
                  pageSizeOptions: ["5", "10", "20", "30"],
                  onChange: (page, pageSize) =>
                    handlePagination(page, pageSize),
                  // page
                  total: !isEmpty(search)
                    ? manageOrganizationRows.length
                    : manage_organization_list && manage_organization_list
                    ? manage_organization_list.total
                    : "",
                  showTotal: (total, pageSize) => {
                    const indexOfLastRow =
                      pageSize && pageSize.length > 0 && pageSize[1];
                    const indexOfFirstRow =
                      pageSize && pageSize.length > 0 && pageSize[0];

                    return (
                      <p
                        style={{
                          fontFamily: "Poppins",
                          fontSize: "12px",
                        }}
                      >
                        Showing rows {indexOfFirstRow} to {indexOfLastRow} of{" "}
                        {!isEmpty(search)
                          ? manageOrganizationRows.length
                          : manage_organization_list &&
                            manage_organization_list.pagination
                          ? manage_organization_list.pagination.total
                          : total}
                      </p>
                    );
                  },
                }}
                sortDirections={"ascend"}
                loading={tableLoading ? true : false}
                showSorterTooltip={"sorter-icon"}
                scroll={{ y: "100%", x: 1125 }}
              />
            </Col>
          </Row>
        </Col>
        <Modal
          open={confirmationModal}
          onOk={() => {
            api
              .post("/org/updatestatus", {
                organizationId: organizationId._id,
                status: organizationId.status === 2 ? 1 : 2,
              })
              .then((res) => {
                toast.success(
                  `${
                    organizationId.status === 2
                      ? "Organization activated successfully"
                      : "Organization deactivated successfully"
                  }`
                );
                dispatch(loadManageOrganizationList(orgPayload));
                return res.data;
              })
              .catch((error) => {
                const errorMsg =
                  (error &&
                    error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                  (error &&
                    error.response &&
                    error.response.data &&
                    error.response.data.error) ||
                  (error && error.message);

                toast.error(errorMsg || "There is an issue while login");
                Promise.reject(error);
              });
            setConfirmationModal(false);
          }}
          closeIcon
          maskClosable={false}
          okText={organizationId.status === 2 ? `Active` : `Deactive`}
          cancelText={"Cancel"}
          okType="danger"
          // okButtonProps={{
          //   disabled: isButtonDisabled ? true : false,
          // }}
          onCancel={() => setConfirmationModal(false)}
          height={300}
          footer={(_, { OkBtn, CancelBtn }) => (
            <div className="text-center flex justify-center">
              <CancelBtn />
              <div className="ml-3">
                <OkBtn />
              </div>
            </div>
          )}
        >
          <div className="text-center w-[100%] p-7">
            {organizationId.status === "1" ? (
              <div className="flex justify-center w-[100%]">
                <BiLock className="mb-2 text-center text-[#e74c3c] font-bold text-[40px]" />
              </div>
            ) : (
              <div className="flex justify-center w-[100%]">
                <BiLockOpen className="mb-2 text-center text-[#08a35ae0] font-bold text-[40px]" />
              </div>
            )}
            {/* <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" /> */}
            <h1 className="font-label text-center text-[16px] font-bold">
              Are you sure you want to{" "}
              {organizationId.status === 2 ? `Active` : `Deactive`} the
              Organization?
            </h1>
          </div>
        </Modal>
      </Row>
    </React.Fragment>
  );
};

ManageOrganization.propTypes = {
  location: PropTypes.any,
  itemId: PropTypes.any,
  organizationId: PropTypes.any,
  partyName: PropTypes.any,
  ledgerLoading: PropTypes.any,
};

export default ManageOrganization;
